import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=f0cc195c"
import script from "./PaymentsView.vue?vue&type=script&lang=js"
export * from "./PaymentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports